// Absolute angles, independent of the property's elevation palette and range.
export const SLOPE_STOPS=Object.freeze([
 {degrees:20,color:'#22c55e'},
 {degrees:25,color:'#facc15'},
 {degrees:30,color:'#f97316'},
 {degrees:35,color:'#ef4444'},
 {degrees:40,color:'#a855f7'},
 {degrees:45,color:'#3b82f6'},
].map(Object.freeze));
export const SLOPE_INTERVAL=.25;
const rgb=color=>[1,3,5].map(at=>parseInt(color.slice(at,at+2),16));
export function sampleSlopeColor(degrees){
 if(!Number.isFinite(degrees)||degrees<SLOPE_STOPS[0].degrees||degrees>90)return null;
 const last=SLOPE_STOPS.at(-1);
 if(degrees>=last.degrees)return rgb(last.color);
 const upper=SLOPE_STOPS.findIndex(stop=>stop.degrees>degrees),a=SLOPE_STOPS[upper-1],b=SLOPE_STOPS[upper];
 const fraction=(degrees-a.degrees)/(b.degrees-a.degrees),start=rgb(a.color),end=rgb(b.color);
 return start.map((value,index)=>Math.round(value+(end[index]-value)*fraction));
}
export function slopeGradientCss(){
 const first=SLOPE_STOPS[0].degrees,span=SLOPE_STOPS.at(-1).degrees-first;
 return `linear-gradient(90deg, ${SLOPE_STOPS.map(stop=>`${stop.color} ${(stop.degrees-first)/span*100}%`).join(', ')})`;
}
